<template>
  <div class="col-sm-12 nopads">
    <form
      v-if="observationCollectionUpdate"
      class="col-sm-12 editor-form"
    >
      <h2 class="editor-header px-1" v-if="observationCollectionUpdate.id && observationCollectionUpdate.id > 0">
        {{ $t('observation_collections.edit') }}
      </h2>
      <h2 class="editor-header px-1" v-else>
        {{ $t('observation_collections.add') }}
      </h2>
      <span class="span-title p-2">
        {{ $t('common.name') }}
      </span>
      <div
        class="title p-2"
        label-for="name"
      >
        <input
          id="name"
          v-model="observationCollectionUpdate.name"
          type="text"
          class="form-control form-control-sm"
          size="mb"
        >
      </div>
      <span class="span-title p-2">
        {{ $t('menu.observation_types') }}
      </span>
      <div
        class="p-2"
        label-for="observation_types"
      >
        <multiselect
          v-model="observationTypesSelected"
          :options="observationTypeOptions"
          :multiple="true"
          :close-on-select="false"
          label="text"
          track-by="value"
          :searchable="true"
          :selected-label="$t('common.selected')"
          :select-label="$t('common.select')"
          :deselect-label="$t('common.remove_selection')"
          :placeholder="$t('pricing_model_conversion.select_code')"
          :disabled="loading"
        >
          <template
            #singleLabel="props"
          >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
          </template>
          <template
            #option="props"
          >
            <div class="option__desc">
              <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
            </div>
          </template>
          <template #noResult>
            <span>{{ $t('common.not_found') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('common.no_results') }}</span>
          </template>
        </multiselect>
      </div>
      <!-- Buttons -->
      <div class="col-sm-12 button-container">
        <button
          class="form-button btn btn-secondary"
          @click.stop="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          v-if="observationCollectionUpdate.id && observationCollectionUpdate.id > 0"
          class="form-button btn btn-danger"
          @click.stop="confirmDeleteObservationCollection"
        >
          {{ $t('common.remove') }}
        </button>
        <button
          class="form-button btn btn-success"
          :disabled="loading"
          @click.stop="submit"
        >
          {{ $t('common.save') }}
        </button>
      </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal
      v-if="deletion"
      size="sm"
      @ok="deleteObservationCollection()"
      @close="deletion = false"
    >
      <div class="modal-body">
        <span>{{ $t('common.confirm_delete') }}</span>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'ObservationCollectionEditor',
    components: {BaseModal},
    mixins: [restApi],
    props: {
        observationCollection: {
            type: Object,
            default: null
        },
        observationTypes: {
            type: Array,
            default() {
                return []
            }
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            observationCollectionUpdate: JSON.parse(JSON.stringify(this.observationCollection)),
            observationTypeOptions: [],
            deletion: false,
            observationTypesSelected: [],
        }
    },
    mounted: function () {
        if(this.observationTypes && this.observationTypes.length > 0) {
            this.observationTypeOptions.push({
                value: null,
                text: this.$t('observation_collections.observation_type_select')
            })
            this.observationTypes.forEach(observationType => {
                if(observationType.id && observationType.name) {
                    this.observationTypeOptions.push({
                        value: observationType.id,
                        text: observationType.name
                    })
                }
            })
        }
        if(this.observationCollection && this.observationCollection.observation_types && this.observationCollection.observation_types.length > 0) {
            this.observationCollection.observation_types.forEach(observationType => {
                this.observationTypesSelected.push({
                    value: observationType.id,
                    text: observationType.name
                })
            })
        }
    },
    methods: {
        setDefaultValues: function (observationCollection) {
            if (!observationCollection.name) {
                this.showAlert(this.$t('observation_collections.name_missing'))
                return undefined
            }
            if(this.observationTypesSelected) {
                let selectedIds = []
                this.observationTypesSelected.forEach(observationTypeSelected => {
                    selectedIds.push({id: observationTypeSelected.value})
                })
                observationCollection.observation_types = selectedIds
            }
            return observationCollection
        },

        submit: function () {
            var json = this.setDefaultValues(this.observationCollectionUpdate)
            if (json !== undefined) {
                this.loading = true
                if(json.id && json.id > 0) {
                    this.restUpdate(this.observationCollectionUrl, json, this.success, this.fail)
                } else {
                    this.restAdd(this.observationCollectionUrl, json, this.success, this.fail)
                }
            }
        },

        deleteObservationCollection: function () {
            this.deletion = false
            this.loading = true
            var url = this.observationCollectionUrl + '/' + this.observationCollectionUpdate.id
            this.restDelete(url, this.success, this.fail)
        },

        confirmDeleteObservationCollection() {
            if (!this.loading) {
                this.deletion = true
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
